import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectExpandedModsDialog,
  selectIsEditExistingMod,
  selectIsEditMod,
  selectShiftDifferentialDescriptionTypes,
  selectShiftDifferentialTemplateTypes,
  selectShiftDifferentialTypes,
} from 'store/redux-store/placement-mods/selectors';
import { PayrollShiftDiffGrid } from './PayrollShiftDiffGrid';
import { payrollShiftDiffModStyles } from './PayrollShiftDiffMod.styles';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { getFormattedPayrollShiftDifferential } from '../../ModificationsUtils';
import { Template } from '../../CommonComponents/Template';

export const PayrollShiftDiffMod = () => {
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const isModEdit = useSelector(selectIsEditMod);
  const isExpanded = useSelector(selectExpandedModsDialog);
  const { classes } = payrollShiftDiffModStyles({ isExpanded, isModEdit });
  const shiftDifferentialTemplateTypes = useSelector(selectShiftDifferentialTemplateTypes);
  const shiftDifferentialTypes = useSelector(selectShiftDifferentialTypes);
  const shiftDifferentialDescriptionTypes = useSelector(selectShiftDifferentialDescriptionTypes);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const [isTemplateChanged, setTemplateChanged] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    if (selectedModsDetails?.shiftDifferentials && (isModEdit || isEditExistingMod)) {
      dispatch(
        placementModsAction.setEditPayrollShiftDiffRows(
          getFormattedPayrollShiftDifferential(
            selectedModsDetails?.shiftDifferentials,
            shiftDifferentialTypes,
            shiftDifferentialDescriptionTypes,
            isModEdit
          ),
        ),
      );
    }
  }, [selectedModsDetails.shiftDifferentials, isModEdit]);
  return (
    <Grid>
      <Grid className={classes.gridRow}>
        <Template
          isExpanded={isExpanded}
          isModEdit={isModEdit}
          options={shiftDifferentialTemplateTypes}
          setTemplateChanged={setTemplateChanged}
        />
      </Grid>
      <Grid className={classes.gridRow}>
        <PayrollShiftDiffGrid
          payrollShiftDiffRequests={selectedModsDetails.shiftDifferentials}
          isTemplateChanged={isTemplateChanged}
          setTemplateChanged={setTemplateChanged}
        />
      </Grid>
    </Grid>
  );
};
